var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1888 2.04199C14.7238 2.04199 11.9121 4.85366 11.9121 8.31866C11.9121 11.7837 14.7238 14.5953 18.1888 14.5953C21.6538 14.5953 24.4654 11.7837 24.4654 8.31866C24.4654 4.85366 21.6538 2.04199 18.1888 2.04199Z",
    fill: "#344054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42016 15.2021C5.28516 15.2021 3.53516 16.9405 3.53516 19.0872C3.53516 21.2338 5.27349 22.9722 7.42016 22.9722C9.55516 22.9722 11.3052 21.2338 11.3052 19.0872C11.3052 16.9405 9.55516 15.2021 7.42016 15.2021Z",
    fill: "#344054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3897 19.3896C17.5813 19.3896 16.1113 20.8596 16.1113 22.668C16.1113 24.4763 17.5813 25.9463 19.3897 25.9463C21.198 25.9463 22.668 24.4763 22.668 22.668C22.668 20.8596 21.198 19.3896 19.3897 19.3896Z",
    fill: "#344054"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble);
export default __webpack_public_path__ + "static/media/bubble.6ce2955851e071006179b6cac0ed4c5f.svg";
export { ForwardRef as ReactComponent };